'use client';

import { useTranslation } from 'react-i18next';

import {
  formatCompensationAmount,
  resolveCompensation,
  type CompensationFields,
} from '@kit/auditions/lib';

/**
 * The pay shown on a casting (BAL-1205): "CHF 250 per show". Renders nothing
 * when the casting has no displayable pay. Shared by the casting card and the
 * public detail page so both say the same thing.
 */
export function CastingCompensation({
  audition,
  className,
}: {
  audition: CompensationFields;
  className?: string;
}) {
  const { t, i18n } = useTranslation('auditions');
  const compensation = resolveCompensation(audition);
  if (!compensation) return null;

  const amount = formatCompensationAmount(compensation, i18n.language || 'en');

  return (
    <span className={className} data-test="casting-compensation">
      {compensation.unit
        ? t(`compensationPer.${compensation.unit}`, { amount })
        : amount}
    </span>
  );
}
